import React, { useCallback, useEffect, useMemo, useState } from 'react';
import http from '../../api/http';
import { useAuth } from '../../context/AuthContext';
import './mobile.css';

export default function MobileMePage() {
  const auth = useAuth();
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [trainingPreview, setTrainingPreview] = useState([]);
  const [checkinPreview, setCheckinPreview] = useState([]);

  useEffect(() => {
    const n = auth?.user?.name || '';
    setName(n);
  }, [auth?.user?.name]);

  const canSave = useMemo(() => String(name || '').trim().length > 0, [name]);

  const refreshPreviews = useCallback(async () => {
    // Preview is best-effort: any 403/404 should not break the page.
    try {
      const tr = await http.get('/education-training/training-records', { __silent: true });
      const list = Array.isArray(tr.data) ? tr.data : [];
      setTrainingPreview(list.slice(0, 5));
    } catch (e) {
      setTrainingPreview([]);
    }

    try {
      const ck = await http.get('/behavior/daily-checkin/my', { params: { page: 1, pageSize: 5 }, __silent: true });
      const list = Array.isArray(ck.data?.list) ? ck.data.list : [];
      setCheckinPreview(list);
    } catch (e) {
      setCheckinPreview([]);
    }
  }, []);

  useEffect(() => {
    refreshPreviews();
  }, [refreshPreviews]);

  const save = async (e) => {
    e?.preventDefault?.();
    if (!canSave) return;

    setSaving(true);
    setError('');
    setSuccess('');

    try {
      await http.put('/me', { name: String(name || '').trim() });
      await auth?.refreshMe?.();
      setSuccess('个人资料已更新');
    } catch (err) {
      setError(err?.response?.data?.message || err?.response?.data?.error || err?.message || '保存失败');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="m-section">
      <div className="m-card m-cardPad">
        <div className="m-h2">个人资料</div>
        <div className="m-muted">可编辑姓名（其余字段以系统为准）。</div>
        {error ? <div className="m-alert m-alertErr" style={{ marginTop: 10 }}>{error}</div> : null}
        {success ? <div className="m-alert" style={{ marginTop: 10 }}>{success}</div> : null}
      </div>

      <form className="m-card m-cardPad m-form" onSubmit={save}>
        <div className="m-field">
          <div className="m-label">账号</div>
          <input className="m-input" value={auth?.user?.username || ''} disabled />
        </div>

        <div className="m-field">
          <div className="m-label">姓名 *</div>
          <input className="m-input" value={name} onChange={(e) => setName(e.target.value)} placeholder="请输入姓名" />
        </div>

        <button className="btn" type="submit" disabled={!canSave || saving}>
          {saving ? '保存中...' : '保存'}
        </button>
      </form>

      <div className="m-card m-cardPad">
        <div className="m-h2">培训记录</div>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
          <a className="btn btn-outline" href="/m/me/training-records">查看全部培训记录</a>
          <button className="btn btn-secondary" onClick={refreshPreviews} type="button">刷新</button>
        </div>
        {trainingPreview.length ? (
          <div className="m-list">
            {trainingPreview.map((r, idx) => (
              <div key={r?.plan_id || idx} className="m-item">
                <div className="m-itemTitle">{r?.training_name || r?.plan_name || '培训记录'}</div>
                <div className="m-itemMeta">{r?.training_start_date ? String(r.training_start_date).slice(0, 10) : '—'}</div>
              </div>
            ))}
          </div>
        ) : (
          <div className="m-alert">暂无可显示的培训记录（可能无权限或暂无数据）</div>
        )}
      </div>

      <div className="m-card m-cardPad">
        <div className="m-h2">打卡历史</div>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 10 }}>
          <a className="btn btn-outline" href="/m/checkin">进入日常打卡</a>
          <button className="btn btn-secondary" onClick={refreshPreviews} type="button">刷新</button>
        </div>
        {checkinPreview.length ? (
          <div className="m-list">
            {checkinPreview.map((it) => (
              <div key={it.id} className="m-item">
                <div className="m-itemTitle">{it.category || '—'}</div>
                <div className="m-itemMeta">{it.created_at ? String(it.created_at).replace('T', ' ').slice(0, 19) : '—'}</div>
              </div>
            ))}
          </div>
        ) : (
          <div className="m-alert">暂无可显示的打卡历史（可能无权限或暂无数据）</div>
        )}
      </div>
    </div>
  );
}
